import $ from "jquery";

export const getScreenBackgroundColor = (id: string) =>
  $(`#screen-container-${id}`).css("background-color");
export const setScreenBackgroundColor = (id: string, value: string) =>
  $(`#screen-container-${id}`).css("background-color", `${value}`);
